import { DatePicker, Input } from 'antd'
import dateInputLocalePtBR from 'main/common/components/form-fields/input/inner/DateInputLocalePtBR.json'
import { LoadingIconCP } from 'main/common/components/icons/LoadingIconCP'
import { SearchIconCP } from 'main/common/components/icons/SearchIconCP'
import React from 'react'
import styled from 'styled-components'
import { FormItemICP } from '../inner/FormItemICP'
import { IFormItemInputCommonProps } from '../inner/interfaces/IFormItemInputCommonProps'
import { FontSizeTP } from 'main/config/theme/ThemeTypes'
import { InputMaskTypeEnum } from 'main/common/enums/InputMaskTypeEnum'
import { FormModel } from 'main/common/form-state-manager/FormModel'
import TextArea from 'antd/lib/input/TextArea'

export type InputTypeTP = 'text' | 'email' | 'number' | 'password' | 'search' | 'date' | 'tel' | 'textArea'

export interface IInputCPProps<FModelTP extends FormModel> extends IFormItemInputCommonProps<FModelTP> {
    type?: InputTypeTP
    icon?: JSX.Element
    min?: number
    max?: number
    loading?: boolean
    showTime?: boolean
    autoFocus?: boolean
    placeholder?: string
    prefix?: boolean
    allowClear?: boolean
    disabled?: boolean
    maxlength?: number
    onInput?:any
}

/**
 * COMPONENTE
 * Input generico para formularios.
 *
 * NOTE: Caso este componente seja controlado via 'form state manager' seu valor nao eh determinado diretamente pela prop 'value'.
 */
export function InputCP<FModelTP extends FormModel = any>(props: IInputCPProps<FModelTP>): JSX.Element {

    function renderInput(): JSX.Element {

        let suffixIcon: JSX.Element | undefined

        if (!!props.loading)
            suffixIcon = <LoadingIconCP size={14}/>

        else if (!!props.icon)
            suffixIcon = props.icon

        else if (props.type === 'search')
            suffixIcon = <SearchIconCP size={14}/>

        if (props.type === 'date') {
            return (
                <DatePicker
                    locale={dateInputLocalePtBR}
                    suffixIcon={suffixIcon}
                    placeholder={props.placeholder}
                    showTime={props.showTime}
                    allowClear={props.allowClear}
                    disabled={props.disabled}
                />
            )
        }

        if(props.type === 'textArea'){
            return (
                <TextArea rows={4} 
                allowClear={true}
                />
            )
        }

        return (
            <Input
                type={props.type ?? 'text'}
                suffix={!props.prefix ? suffixIcon : undefined}
                prefix={props.prefix ? suffixIcon : undefined}
                min={props.min}
                max={props.max}
                onInput={props.onInput}
                disabled={props.disabled}
                autoFocus={props.autoFocus}
                allowClear={props.allowClear}
                placeholder={props.placeholder}
                maxLength={props.maxlength ?? (props.mask === InputMaskTypeEnum.PHONE ? 15 : undefined)}
            />
        )
    }

    return (
        <InputWrapperSCP fontSize={props.fontSize ?? 'normal'}>
            <FormItemICP<FModelTP, IFormItemInputCommonProps<FModelTP>>
                label={props.label}
                onChange={props.onChange}
                onBlur={props.onBlur}
                fieldName={props.fieldName}
                formStateManager={props.formStateManager}
                required={props.required}
                width={props.width}
                onFormSubmit={props.onFormSubmit}
                value={props.value}
                mask={props.mask}
                fontSize={props.fontSize}
                errorMessage={props.errorMessage}
                noValidation={props.noValidation}
                debug={props.debug}
                reloadField={props.reloadField}
                marginTop={props.marginTop}
                marginRight={props.marginRight}
                marginBottom={props.marginBottom}
                marginLeft={props.marginLeft}
                hint={props.hint}
            >
                {renderInput()}
            </FormItemICP>
        </InputWrapperSCP>
    )
}

const InputWrapperSCP = styled.div<{ fontSize: FontSizeTP }>`
    width: 100%;
`
